import { render, staticRenderFns } from "./ShowAskExperience.vue?vue&type=template&id=f52005a4&scoped=true&"
import script from "./ShowAskExperience.vue?vue&type=script&lang=ts&"
export * from "./ShowAskExperience.vue?vue&type=script&lang=ts&"
import style0 from "./ShowAskExperience.vue?vue&type=style&index=0&id=f52005a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52005a4",
  null
  
)

export default component.exports